import { createContext } from "react";
import { Blocker, BlockerFunction } from "react-router-dom";

export interface BlockerContextType {
  blocker: Blocker;
  register: (fn: BlockerFunction) => () => void;
}

export const BlockerContext = createContext<BlockerContextType | null>(null);
